<template>
  <div>
    <v-row>
      <v-breadcrumbs :items="breadcrumbs" large>
        <template v-slot:divider>
          <v-icon>mdi-menu-right</v-icon>
        </template>
      </v-breadcrumbs>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        Total Applied:
        <span
          class="mx-3 text-body-1 font-weight-bold text-decoration-underline"
        >
          {{ batch.formattedTotalApplied }}</span
        >
        <span v-if="!canPostBatch" class="text-caption error--text">
          * Total applied does not equal payment amount.</span
        >
        <v-btn
          text
          color="primary"
          :dark="!noEdit && canPostBatch"
          :disabled="noEdit || !canPostBatch"
          @click="post"
          >Post Payment</v-btn
        >
      </v-toolbar>
    </v-row>
    <v-toolbar flat>
      <v-switch
        v-model="groupInvoices"
        label="Group by client"
        inset
        hide-details
        dense
      ></v-switch>
      <v-spacer></v-spacer>
      <export-batch-button
        v-if="noEdit"
        :large="true"
        :paymentBatchId="batch.paymentBatchId"
      ></export-batch-button>

      <invoices-modal v-if="!noEdit"></invoices-modal>
    </v-toolbar>
    <invoices-table v-if="!groupInvoices" :noEdit="noEdit"></invoices-table>
    <grouped-invoices-table
      v-if="groupInvoices"
      :noEdit="noEdit"
    ></grouped-invoices-table>
  </div>
</template>
<script>
import InvoicesModal from "./invoices-modal.vue";
import ExportBatchButton from "./export-batch-button.vue";
import InvoicesTable from "./invoices-table.vue";
import GroupedInvoicesTable from "./grouped-invoices-table.vue";
export default {
  props: ["noEdit"],
  components: {
    InvoicesModal,
    ExportBatchButton,
    InvoicesTable,
    GroupedInvoicesTable,
  },
  data() {
    return {
      groupInvoices: true,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "Payment",
          to: "all-checks",
        },
        {
          text: `${this.batch.formattedPaymentDate}`,
        },
        {
          text: `${this.batch.checkNumber}`,
        },
        {
          text: `${this.batch.formattedTotalAmount}`,
        },
      ];
    },
    batch() {
      return this.$store.state.paymentBatchModule.selectedBatch;
    },
    canPostBatch() {
      return this.batch?.totalAmount == this.batch?.totalApplied;
    },
  },
  methods: {
    async post() {
      this.$store.commit("uxModule/setShowLoader", true);
      let success = await this.$store.dispatch("paymentBatchModule/postBatch", {
        paymentBatchId: this.batch.paymentBatchId,
      });
      this.$store.commit("uxModule/setShowLoader", false);
      if (!success) {
        this.$store.commit("uxModule/setSnackbarMsg", "Failed to post batch");
        this.$store.commit("uxModule/setShowSnackbar", true);
      } else {
        this.$router.push({ name: "AllBatches" });
      }
    },
  },
};
</script>
